"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _Theme = _interopRequireDefault(require("../common/Theme"));
var _iconsCheck = require("../resources/icons-check.svg");
var _iconsChevronDouble = require("../resources/icons-chevron-double.svg");
var _TextField = _interopRequireDefault(require("./TextField"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SelectMenu = exports["default"] = /*#__PURE__*/function (_Component) {
  function SelectMenu(props) {
    var _this;
    _classCallCheck(this, SelectMenu);
    _this = _callSuper(this, SelectMenu, [props]);
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inherits(SelectMenu, _Component);
  return _createClass(SelectMenu, [{
    key: "onChange",
    value: function onChange(e) {
      var onChange = this.props.onChange;
      if (e.target.value === undefined) return;
      if (onChange) onChange(e);
    }
  }, {
    key: "renderGroup",
    value: function renderGroup(group) {
      var _this2 = this;
      var items = this.props.items;
      return [/*#__PURE__*/_react["default"].createElement(_material.ListSubheader, {
        className: "klayo-selectmenu_group"
      }, group), items.filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          filter = _ref2[1];
        return filter.group === group;
      }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          filter = _ref4[1];
        return _this2.renderItem(key, filter);
      })];
    }
  }, {
    key: "renderItem",
    value: function renderItem(key, filter) {
      var _this$props = this.props,
        dense = _this$props.dense,
        getItemLabel = _this$props.getItemLabel,
        disableItem = _this$props.disableItem,
        showSelectionIcon = _this$props.showSelectionIcon;
      return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
        className: "klayo-selectmenu_item " + (dense ? "klayo-selectmenu_item-dense " : ""),
        key: key,
        disabled: disableItem ? disableItem(filter) : false,
        value: filter
      }, /*#__PURE__*/_react["default"].createElement(_material.ListItemText, null, getItemLabel ? getItemLabel(filter) : filter.label), showSelectionIcon && /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_iconsCheck.ReactComponent, null)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        label = _this$props2.label,
        items = _this$props2.items,
        placeholder = _this$props2.placeholder,
        disabled = _this$props2.disabled,
        className = _this$props2.className,
        sx = _this$props2.sx,
        dense = _this$props2.dense,
        onChange = _this$props2.onChange,
        firstValueDefault = _this$props2.firstValueDefault,
        getItemLabel = _this$props2.getItemLabel,
        clearable = _this$props2.clearable,
        disableItem = _this$props2.disableItem,
        noSelectionError = _this$props2.noSelectionError,
        groups = _this$props2.groups,
        autoFocus = _this$props2.autoFocus;
      var value = this.props.value;
      var defaultValue = this.props.defaultValue ? this.props.defaultValue : firstValueDefault ? items[0][1] : null;
      if (!value) value = defaultValue;
      return /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        className: "klayo-selectmenu" + (dense ? " klayo-selectmenu-dense" : "") + (className ? " " + className : "") + (groups ? " klayo-selectmenu-hasgroups" : ""),
        select: true,
        label: label,
        dense: dense,
        value: value,
        error: noSelectionError && value === null,
        clearable: clearable,
        defaultValue: defaultValue,
        placeholder: placeholder,
        autoFocus: autoFocus,
        disabled: disabled,
        onChange: this.onChange.bind(this),
        SelectProps: {
          MenuProps: {
            classes: {
              list: ".MuiMenu-list" + (groups ? " klayo-selectmenu_list-hasgroups" : "") + (dense ? " klayo-selectmenu_list-dense" : "")
            }
          },
          IconComponent: function IconComponent() {
            return /*#__PURE__*/_react["default"].createElement(_iconsChevronDouble.ReactComponent, {
              className: "klayo-selectmenu_dropbutton"
            });
          },
          autoWidth: false,
          displayEmpty: true,
          renderValue: function renderValue(value) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: "klayo-selectmenu_value"
            }, value !== "" ? getItemLabel ? getItemLabel(value) : value.label : placeholder ? /*#__PURE__*/_react["default"].createElement("div", {
              className: "klayo-selectmenu_placeholder"
            }, placeholder) : "");
          }
        },
        sx: _objectSpread(_objectSpread({}, sx), {}, {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: _Theme["default"].getStyleVar("--neon-blue-nb-200")
            },
            "&:hover fieldset": {
              borderColor: _Theme["default"].getStyleVar("--neon-blue-nb-300")
            },
            "&.Mui-focused fieldset": {
              borderWidth: "2px",
              borderColor: _Theme["default"].getStyleVar("--neon-blue-nb-500")
            }
          }
        })
      }, groups && groups.map(function (g) {
        return _this3.renderGroup(g);
      }), !groups && items.map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          filter = _ref6[1];
        return _this3.renderItem(key, filter);
      }));
    }
  }]);
}(_react.Component);
_defineProperty(SelectMenu, "defaultProps", {
  noSelectionError: false,
  groups: null,
  showSelectionIcon: true
});